import axios from '@/axios';

// URL and endpoint constants
// Respondents
const CREATE_URL = '/respondents';

export default {

  getRespondent() {
    return {
      auth_token: localStorage.getItem('Authorization'),
      current_evaluation: localStorage.getItem('CurrentEvaluation'),
      completed_sections: localStorage.getItem('CompletedSections'),
    };
  },

  async setAuthHeaders(response) {
    axios.defaults.headers.Authorization = response.data.auth_token;
  },

  // POST
  create(data) {
    return axios.post(CREATE_URL, data);
  },
};



// WEBPACK FOOTER //
// ./src/api/respondents.js